import React from "react";
import "./EditorLeftMenuAiShadowControls.css";
import AiShadowControlMenu from "./AiShadowControlMenu";

const EditorLeftMenuAiShadowControls = ({
  onApplyAiShadowCloudinary,
  shadowBusy = false,
  shadowError = null,
}) => {
  return (
    <div className="ai-shadow-controls-container">
      <h1>AI Shadow</h1>
      {shadowError ? (
        <p style={{ color: "#f66", fontSize: 13, marginBottom: 8 }}>{shadowError}</p>
      ) : null}
      <AiShadowControlMenu
        onShadowSelect={() => {}}
        onApplyCloudinaryShadow={onApplyAiShadowCloudinary}
        shadowBusy={shadowBusy}
      />
    </div>
  );
};

export default EditorLeftMenuAiShadowControls;
